import React, { useEffect, useState } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { OTP_SCREEN } from '../../Constants/Constants';

const OtpTimer = ({ timeSrc, resendOtpHandler, disabledOtpLink }) => {
  const [time, setTime] = useState(timeSrc);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const setTimeValues = value => {
    const mins = Math.floor(value / 60);
    const secs = value - mins * 60;
    setMinutes(mins);
    setSeconds(secs);
    setTime(prevTime => prevTime - 1);
  };

  useEffect(() => {
    setTimeValues(timeSrc);
  }, [timeSrc]);

  useEffect(() => {
    let interId;
    if (time >= 0) {
      interId = setInterval(() => {
        setTimeValues(time);
      }, 1000);
    } else {
      clearInterval(interId);
    }
    return () => {
      interId && clearInterval(interId);
    };
  }, [time]);

  const timerValue = () => {
    return time >= 0 ? (
      <span>
        Your code will expire in {minutes}:{(seconds < 10 && `0${seconds}`) || seconds} seconds
      </span>
    ) : (
      translateWithI18Next(OTP_SCREEN.CODE_EXPIRED_TEXT)
    );
  };

  return (
    <>
      {timerValue()}
      <div>
        <button
          data-testid='resend-otp-testid'
          disabled={disabledOtpLink}
          className={`otp-link-button ${disabledOtpLink ? 'disableOtpLinkCls' : ''}`}
          id='otpResendButton'
          onClick={event => {
            setTime(179);
            resendOtpHandler(event);
          }}
        >
          {translateWithI18Next(OTP_SCREEN.RESEND_CODE)}
        </button>
      </div>
    </>
  );
};
export default OtpTimer;
